import { PanelItem } from '@rta/rta-blueprint-library';

/**
 * Gets the display label text for a panel item
 * Returns the pre-computed displayText from the item (customLabel > displayName > sku)
 */
export const getLabelText = (
	panelItem: PanelItem,
	_isOnUtilityPanel?: boolean
): string => {
	return panelItem.item.displayText;
};
